module.exports = window.T['views/log.html'] || "<logviewer log=\"log\" jump-to-line=\"jumpToLine\"></logviewer>";